import AddNew from 'Components/Atoms/ExpandableItems/AddNew';
import Grid from 'Components/Atoms/Grid/Grid';
import Title from 'Components/Atoms/Title/Title';
import EditButton from 'Components/Molecules/EditButton/EditButton';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {calculateTimeDifference, convertDateToMonthAndYear, convertDateToYear} from 'Services/Date/Date';
import { createCandidateValues, saveCandidateValues } from 'Store/Candidate/Actions';
import { CandidateId } from 'Store/Candidate/PropTypes';
import { getCandidate, getCandidateValuesFromCandidateId } from 'Store/Candidate/Selectors';
import { CANDIDATE_PREDEFINED, FieldType } from 'Store/FieldManagement/PropTypes';
import { StoreState } from 'Store/Reducers';
import containerStyles from './../../Organisms/LayoutContainer/LayoutContainer.module.sass';
import styles from './Projects.module.sass';

const Projects = ({ entity_id, candidate, values, ...props}: WorkExperiencesProps) => {
    const [state, setState] = useState({ isEdit: false });

    const [data, setData] = useState(values?.[CANDIDATE_PREDEFINED.PROJECT]?.value || []);
    useEffect(() => {
        setData(values?.[CANDIDATE_PREDEFINED.PROJECT]?.value || []);
    }, [values]);

    const emptyDataObject = {
        project: '',
        date: '',
    }

    const handleAddEducation = () => setData([...data, emptyDataObject]);

    const handleDeleteEducation = (idx: number) => {
        const tempData = [...data]?.filter((_, tempIdx: number) => tempIdx != idx);
        
        setData(tempData);
    }

    const handleCancel = () => setData(values?.[CANDIDATE_PREDEFINED.PROJECT]?.value || []);

    const handleSave = () => {
        data.sort((a, b) => (a.date < b.date) ? 1 : -1);

        if (values?.[CANDIDATE_PREDEFINED.PROJECT]?.value_id) {
            props.saveCandidateValues(entity_id, {[values?.[CANDIDATE_PREDEFINED.PROJECT]?.value_id]: data});
        } else {
            props.createCandidateValues(entity_id, {[CANDIDATE_PREDEFINED.PROJECT]: data});
        }

        setState((state) => ({
            ...state,
            isEdit: false
        }));
    };

    return <div className={containerStyles['layoutcontainer']} style={{width: '100%'}}>
        <Grid
            position='between'
            align='center'
            axis='horizontal'
        >
            <Title weight='semibold'>Projecten</Title>
            
            <EditButton
                variant='button'
                isEdit={state.isEdit}
                onChange={(value) => setState({
                    ...state,
                    isEdit: value
                })}
                onSave={handleSave}
                />
        </Grid>

        { data.length == 0 &&
            <>
                { state.isEdit && <AddNew onClick={handleAddEducation}>+ Nieuw project toevoegen</AddNew> }
                { !state.isEdit && <div>Geen resultaten...</div> }
            </>
        }

        <div className={styles['work_experience']}>
            <div className={styles['work_experience-list']}>

            {
                data.map((project: any, idx: number) => {
                    return <>
                        <div className={styles['work_experience-list-item']}>
                            {
                                !state.isEdit && <>
                                    <div className={styles['work_experience-list-item--side']}>
                                        {
                                            convertDateToYear(project?.start_date) !== convertDateToYear(project?.end_date)
                                            ? `${ convertDateToYear(project?.start_date) } - ${ project?.end_date ? convertDateToYear(project?.end_date) : 'Heden' }`
                                            : convertDateToYear(project?.start_date)
                                        }
                                    </div>
                                    <div className={styles['work_experience-list-item--content']}>
                                        <div className={styles['work_experience-list-item--content-title']}>
                                            { project?.project }
                                        </div>
                                    </div>
                                </>
                            }
                            {
                                state.isEdit && <>
                                    <div className={styles['work_experience-list-item--side']}>
                                        <div className={styles['work_experience-list-item--side-date']}>
                                            <FormGroup title='Start datum'>
                                                <Field
                                                    type={FieldType.Date}
                                                    value={project?.start_date}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index === idx) ? {...item, start_date: value} : item);

                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                        <div className={styles['work_experience-list-item--side-date']}>
                                            <FormGroup title='Eind Datum'>
                                                <Field
                                                    type={FieldType.Date}
                                                    value={project?.end_date}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index === idx) ? {...item, end_date: value} : item);

                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>

                                        { project?.start_date && <>
                                            <div className={styles['work_experience-list-item--side-computed']}>
                                                <strong>Datum: </strong> {`${convertDateToMonthAndYear(project?.start_date)} - ${project?.end_date ? convertDateToMonthAndYear(project?.end_date) : 'heden'} ` }
                                            </div>
                                            <div className={styles['work_experience-list-item--side-computed']}>
                                                <strong>Duur: </strong> { calculateTimeDifference(project?.start_date, project?.end_date) }
                                            </div>
                                        </> }

                                        <div className={styles['delete']} onClick={() => handleDeleteEducation(idx)}>Project verwijderen</div>
                                    </div>
                                    <div className={styles['work_experience-list-item--content']}>
                                        <div className={styles['work_experience-list-item--content-title']}>
                                            <FormGroup title='Naam'>
                                                <Field
                                                    type={FieldType.Text}
                                                    value={project?.project}
                                                    isEdit={true}
                                                    onChange={(value) => {
                                                        const tempData = [...data].map((item, index) => (index === idx) ? {...item, project: value} : item);
            
                                                        setData(tempData);
                                                    }}
                                                />
                                            </FormGroup>
                                        </div>
                                    </div>
                                </>
                            }
                        </div>
                        { state.isEdit && idx === data.length-1 && <AddNew onClick={handleAddEducation}>+ Nieuw project toevoegen</AddNew> }
                    </>;
                })
            }
            </div>
        </div>
    </div>
}

interface Props {
    entity_id: CandidateId
}

const mapState = (state: StoreState, props: Props) => ({
    candidate: getCandidate(state, props.entity_id),
    values: getCandidateValuesFromCandidateId(state, props.entity_id)
});

const mapDispatch = {
    saveCandidateValues,
    createCandidateValues
};

type WorkExperiencesProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(Projects);